import * as React from 'react'
import { useForm, useWatch, Control, useFormContext, FormProvider } from 'react-hook-form'

interface FormInputs {
  firstName: string
  lastName: string
}

let renderCount = 0

function FirstNameWatched({ control }: { control: Control<FormInputs> }) {
  const firstName = useWatch({
    control,
    name: 'firstName', // without supply name will watch the entire form, or ['firstName', 'lastName'] to watch both
    defaultValue: 'default', // default value before the render
  })

  console.log('FirstNameWatched render')

  return <p>Watch: {firstName}</p> // only re-render at the component level, when firstName changes
}

function SubmissionPayload() {
  const { watch } = useFormContext() // retrieve all hook methods
  const payload = watch()

  return <pre style={{ color: 'white' }}>{JSON.stringify(payload)}</pre>
}

export const DemoFormProvider: React.SFC = () => {
  const methods = useForm<FormInputs>()
  const { register, control, handleSubmit /*, watch */ } = methods

  const onSubmit = (data: FormInputs) => {
    alert(JSON.stringify(data))
  }

  // un-comment this to see the renderCount
  // increased when we change firstName
  // stay the same when lastName is changed

  // const watchFirstName = watch("firstName", "default");
  // console.log(watchFirstName);

  renderCount++

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <label>Render count: {renderCount}</label>
        <label>First Name:</label>
        <input ref={register} name="firstName" />
        <label>Last Name: </label>
        <input ref={register} name="lastName" />
        <input type="submit" />
        <FirstNameWatched control={control} />
        <SubmissionPayload />
      </form>
    </FormProvider>
  )
}
